import { render, staticRenderFns } from "./users-list.vue?vue&type=template&id=5d0066a3&"
import script from "./users-list.vue?vue&type=script&lang=js&"
export * from "./users-list.vue?vue&type=script&lang=js&"
import style0 from "./users-list.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports